import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Models } from '@ibexfusion/models';

export interface ClipData {
  clip: boolean;
  crop: boolean;
  fixedScale: boolean;
  restrict?: string;
  crop_initX: number;
  crop_initY: number;
  minWidth: number;
  minHeight: number;
  imageDimension: { width: number, height: number };
  offsetRight: number;
  offsetBottom: number;
  factor: number;
}

@Component({
    selector: 'image-editor-v2',
    templateUrl: './image-editor-v2.component.html',
    styleUrls: ['./image-editor-v2.component.scss'],
    standalone: false
})

export class ImageEditorV2Component implements OnChanges {

  @Input() rawImagePath: string;
  @Input() rawWidth: number;
  @Input() rawHeight: number;
  @Input() clip: Models.ClippingInformation;
  @Input() data: ClipData;
  @Input() type: string;

  isLandscape: boolean;
  clipResized: Models.ClippingInformation;
  newClip: Models.ClippingInformation;
  newData: ClipData;
  ratio;

  @Output() imageEditorSave = new EventEmitter<any>();

  constructor(private el: ElementRef) {
  }

  ngOnChanges(changes) {
    this.newData = JSON.parse(JSON.stringify(this.data));
    this.isLandscape = this.rawWidth > this.rawHeight;
    this.clipResized = this.calculateResizedClip(this.clip);
    this.newClip = JSON.parse(JSON.stringify(this.clipResized));
    // this.imageEditorSave.emit({ type: this.type, newClip: this.newClip, newData: this.newData });
    if (this.type === 'sixteenToNine') {
      this.ratio = (16 / 9);
    } else if (this.type === 'oneToOne') {
      this.ratio = 1;
    } else if (this.type === 'widgetSize') {
      this.ratio = (36 / 67);
    } else if (this.type === 'fourToThree') {
      this.ratio = (4 / 3);
    }
    this.initSelectionBox();
  }

  initSelectionBox() {
    const selectionBox: any = document.querySelector('.selection-box');
    selectionBox.style.width = this.clipResized.width + 'px';
    selectionBox.style.height = this.clipResized.height + 'px';
    selectionBox.style.top = this.clipResized.offsetY + 'px';
    selectionBox.style.left = this.clipResized.offsetX + 'px';
    const resizeHandles = document.querySelectorAll('.resize-handle');
    let isDragging = false;
    let currentHandle = null;
    let startX, startY, startWidth, startHeight, startLeft, startTop;
    this.updateOverlayMask();
    selectionBox.addEventListener('mousedown', (e) => {
      if (e.target.classList.contains('resize-handle')) return;

      isDragging = true;
      startX = e.clientX;
      startY = e.clientY;
      startLeft = selectionBox.offsetLeft;
      startTop = selectionBox.offsetTop;
    });

    document.addEventListener('mousemove', (e) => {
      const container = selectionBox.parentElement.getBoundingClientRect();
      const containerRect = selectionBox.parentElement.getBoundingClientRect();
      const limitedClientX = Math.max(containerRect.left, Math.min(e.clientX, containerRect.right));
      const limitedClientY = Math.max(containerRect.top, Math.min(e.clientY, containerRect.bottom));

      if (isDragging) {
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        selectionBox.style.left = ((startLeft + dx) >= 0) ? `${startLeft + dx}px` : '0px';
        selectionBox.style.top = ((startTop + dy) >= 0) ? `${startTop + dy}px` : '0px';

        const box = selectionBox.getBoundingClientRect();

        const image: any = document.querySelector('#parent');
        const imageStyles: any = image.getBoundingClientRect();

        const top = box.top - container.top;
        const left = box.left - container.left;

        if ((left + box.width) >= imageStyles.width) {
          selectionBox.style.left = imageStyles.width - box.width + 'px';
        }
        if ((top + box.height) >= imageStyles.height) {
          selectionBox.style.top = imageStyles.height - box.height + 'px';
        }

        this.updateOverlayMask();
      }

      if (currentHandle) {
        const dx = limitedClientX - startX;
        const dy = limitedClientY - startY;

        const box = selectionBox.getBoundingClientRect();
        const image: any = document.querySelector('#parent');
        const imageStyles: any = image.getBoundingClientRect();
        let newWidth: any ;
        let newHeight: any ;
        const maxWidth = this.isLandscape ? this.type === 'oneToOne' ? imageStyles.height : imageStyles.width : imageStyles.width;

        if (currentHandle === 'top-left') {
          if (this.type === 'freeForm') {
            if ((box.left !== imageStyles.left) && ((startWidth - dx) >= 40)) {
              selectionBox.style.width = `${startWidth - dx}px`;
            }
            if ((box.top !== imageStyles.top) && ((startHeight - dy) >= 40) ) {
              selectionBox.style.height = `${startHeight - dy}px`;
            }
            if ((startWidth - dx) >= 40) {
              selectionBox.style.left =  ((startLeft + dx) >= 0) ? `${startLeft + dx}px` : '0px';
            }
            if ((startHeight - dy) >= 40) {
              selectionBox.style.top = ((startTop + dy) >= 0) ? `${startTop + dy}px` : '0px';
            }
          } else {
            newWidth = Math.min(Math.max(40, startWidth - dx), maxWidth);
            newHeight = newWidth / this.ratio;
            if ((box.left !== imageStyles.left) && (box.top !== imageStyles.top)) {
              selectionBox.style.width = newWidth + 'px';
              selectionBox.style.height = newWidth / this.ratio  + 'px';
            }
            if (box.top !== imageStyles.top) {
              selectionBox.style.left =  (Math.min(startLeft + dx, startLeft + startWidth - 40) >= 0) ? Math.min(startLeft + dx, startLeft + startWidth - 40) + 'px' : '0px';
            }
            if (box.left !== imageStyles.left) {
              selectionBox.style.top = ((startTop + (startHeight - newHeight)) >= 0) ? (startTop + (startHeight - newHeight)) + 'px' : '0px';
            }
          }
        } else if (currentHandle === 'top-right') {
          if (this.type === 'freeForm') {
            if (((box.right <= imageStyles.right) || ((startWidth + dx) < box.width)) && ((startWidth + dx) >= 40)) {
              selectionBox.style.width = `${startWidth + dx}px`;
            }
            if ((box.top !== imageStyles.top) && ((startHeight - dy) >= 40)) {
              selectionBox.style.height = `${startHeight - dy}px`;
            }
            if ((startHeight - dy) >= 40) {
              selectionBox.style.top = ((startTop + dy) >= 0) ? `${startTop + dy}px` : '0px';
            }
          } else {
            newWidth = Math.min(Math.max(40, startWidth + dx), maxWidth);
            newHeight = newWidth / this.ratio;
            if (((box.right <= imageStyles.right) || ((startWidth + dx) < box.width)) && (box.top !== imageStyles.top)) {
              selectionBox.style.width = newWidth + 'px';
              selectionBox.style.height = newWidth / this.ratio  + 'px';
            }
            if (box.right <= imageStyles.right) {
              selectionBox.style.top = ((startTop + (startHeight - newHeight)) >= 0) ? (startTop + (startHeight - newHeight)) + 'px' : '0px';
            }
          }
        } else if (currentHandle === 'bottom-left') {
          if (this.type === 'freeForm') {
            if ((box.left !== imageStyles.left) && ((startWidth - dx) >= 40)) {
              selectionBox.style.width = `${startWidth - dx}px`;
            }
            if (((box.bottom <= imageStyles.bottom) || ((startHeight + dy) < box.height)) && ((startHeight + dy) >= 40) ) {
              selectionBox.style.height = `${startHeight + dy}px`;
            }
            if ((startWidth - dx) >= 40) {
              selectionBox.style.left =  ((startLeft + dx) >= 0) ? `${startLeft + dx}px` : '0px';
            }
          } else {
            newWidth = Math.min(Math.max(40, startWidth - dx), maxWidth);
            if (((box.bottom <= imageStyles.bottom) || ((newWidth / this.ratio) < box.height)) && (box.left !== imageStyles.left)) {
              selectionBox.style.width = newWidth + 'px';
              selectionBox.style.height = newWidth / this.ratio  + 'px';
            }
            if (box.bottom <= imageStyles.bottom) {
              selectionBox.style.left =  (Math.min(startLeft + dx, startLeft + startWidth - 40) >= 0) ? Math.min(startLeft + dx, startLeft + startWidth - 40) + 'px' : '0px';
            }
          }
        } else if (currentHandle === 'bottom-right') {
          if (this.type === 'freeForm') {
            if (((box.right <= imageStyles.right) || ((startWidth + dx) < box.width) ) && ((startWidth + dx) >= 40) ) {
              selectionBox.style.width = `${startWidth + dx}px`;
            }
            if (((box.bottom <= imageStyles.bottom) || ((startHeight + dy) < box.height)) && ((startHeight + dy) >= 40) ) {
              selectionBox.style.height = `${startHeight + dy}px`;
            }
          } else {
            newWidth = Math.min(Math.max(40, startWidth + dx), maxWidth);
            if (((box.right <= imageStyles.right) || (newWidth < box.width)) && ((box.bottom <= imageStyles.bottom) || ((newWidth / this.ratio) < box.height))) {
              selectionBox.style.width = newWidth + 'px';
              selectionBox.style.height = newWidth / this.ratio  + 'px';
            }
          }
        } else if (currentHandle === 'top') {
          if (this.type === 'freeForm') {
            if ((startHeight - dy) >= 40) {
              selectionBox.style.top = ((startTop + dy) >= 0) ? `${startTop + dy}px` : '0px';
            }
            if ((box.top !== imageStyles.top) && ((startHeight - dy) >= 40) ) {
              selectionBox.style.height = `${startHeight - dy}px`;
            }
          } else {
            newHeight = Math.max(40, startHeight - dy);
            if (((box.right <= imageStyles.right) || ((newHeight * this.ratio) < box.width)) && (box.top !== imageStyles.top)) {
              selectionBox.style.height = newHeight + 'px';
              selectionBox.style.width = newHeight * this.ratio + 'px';
            }
            if (box.right <= imageStyles.right) {
              selectionBox.style.top = ((startTop + (startHeight - newHeight)) >= 0) ? (startTop + (startHeight - newHeight)) + 'px' : '0px';
            }
          }
        } else if (currentHandle === 'bottom') {
          if (this.type === 'freeForm') {
            if (((box.bottom <= imageStyles.bottom) || ((startHeight + dy) < box.height)) && ((startHeight + dy) >= 40) ) {
              selectionBox.style.height = `${startHeight + dy}px`;
            }
          } else {
            newHeight = Math.max(40, startHeight + dy);
            if (((box.right <= imageStyles.right) || ((newHeight * this.ratio) < box.width)) && ((box.bottom <= imageStyles.bottom) || (newHeight < box.height))) {
              selectionBox.style.height = newHeight + 'px';
              selectionBox.style.width = newHeight * this.ratio + 'px';
            }
          }
        } else if (currentHandle === 'left') {
          if (this.type === 'freeForm') {
            if ((box.left !== imageStyles.left) && ((startWidth - dx) >= 40)) {
              selectionBox.style.width = `${startWidth - dx}px`;
            }
            if ((startWidth - dx) >= 40) {
              selectionBox.style.left =  ((startLeft + dx) >= 0) ? `${startLeft + dx}px` : '0px';
            }
          } else {
            newWidth = Math.min(Math.max(40, startWidth - dx), maxWidth);
            if (((box.bottom <= imageStyles.bottom) || ((newWidth / this.ratio) < box.height)) && (box.left !== imageStyles.left)) {
              selectionBox.style.width = newWidth + 'px';
              selectionBox.style.height = newWidth / this.ratio  + 'px';
            }
            if (box.bottom <= imageStyles.bottom) {
              selectionBox.style.left =  (Math.min(startLeft + dx, startLeft + startWidth - 40) >= 0) ? Math.min(startLeft + dx, startLeft + startWidth - 40) + 'px' : '0px';
            }
          }
        } else if (currentHandle === 'right') {
          if (this.type === 'freeForm') {
            if (((box.right <= imageStyles.right) || ((startWidth + dx) < box.width) ) && ((startWidth + dx) >= 40) ) {
              selectionBox.style.width = `${startWidth + dx}px`;
            }
          } else {
            newWidth = Math.min(Math.max(40, startWidth + dx), maxWidth);
            if (((box.right <= imageStyles.right) || (newWidth < box.width)) && ((box.bottom <= imageStyles.bottom) || ((newWidth / this.ratio) < box.height))) {
              selectionBox.style.width = newWidth + 'px';
              selectionBox.style.height = newWidth / this.ratio  + 'px';
            }
          }
        }
        this.updateOverlayMask();
      }
    });

    document.addEventListener('mouseup', () => {
      if (isDragging) {
        this.onDragged(false);
      }
      if (currentHandle) {
        this.onCrop(false);
      }
      isDragging = false;
      currentHandle = null;
    });

    resizeHandles.forEach(handle => {
      handle.addEventListener('mousedown', (e: any) => {
        e.stopPropagation();
        currentHandle = handle.classList[1]; // Зберігаємо ім'я ручки, наприклад, "top-left"
        startX = e.clientX;
        startY = e.clientY;
        startWidth = selectionBox.offsetWidth;
        startHeight = selectionBox.offsetHeight;
        startLeft = selectionBox.offsetLeft;
        startTop = selectionBox.offsetTop;
      });
    });
  }

  updateOverlayMask() {
    const selectionBox: any = document.querySelector('.selection-box');
    const overlay: any = document.querySelector('.overlay');
    const box = selectionBox.getBoundingClientRect();
    const container = selectionBox.parentElement.getBoundingClientRect();

    const top = box.top - container.top;
    const left = box.left - container.left;
    const bottom = box.bottom - container.top;
    const right = box.right - container.left;
    overlay.style.clipPath = `polygon(
    0% 0%, 0% 100%, 100% 100%, 100% 0%, 0% 0%,
    ${left}px ${top}px, ${right}px ${top}px, ${right}px ${bottom}px, ${left}px ${bottom}px, ${left}px ${top}px
  )`;
  }

  calculateResizedClip(oldClip: Models.ClippingInformation): Models.ClippingInformation {
    const newClip = new Models.ClippingInformation();
    if (this.isLandscape) {
      this.newData.factor = 500 / this.rawWidth;
    } else {
      this.newData.factor = 400 / this.rawHeight;
    }
    if (isNaN(oldClip.width) && this.type === 'widgetSize') {
      newClip.populateFromJSON({ width: 380 * this.newData.factor, height: 670 * this.newData.factor, offsetX: 0, offsetY: 0 });
    } else {
      let width = oldClip.width > this.rawWidth ? this.rawWidth : oldClip.width;
      let height = oldClip.height > this.rawHeight ? this.rawHeight : oldClip.height;
      let offsetX = (oldClip.offsetX + width) < this.rawWidth ? oldClip.offsetX * this.newData.factor : 0;
      let offsetY = (oldClip.offsetY + height) < this.rawHeight ? oldClip.offsetY * this.newData.factor : 0;
      newClip.populateFromJSON({
        width: width * this.newData.factor, height: height * this.newData.factor,
        offsetX: offsetX, offsetY: offsetY
      });
    }

    setTimeout(() => {
        if (this.el?.nativeElement?.parentNode) {
          const image = this.el.nativeElement.parentNode.querySelector('img').getBoundingClientRect();
          this.newData.imageDimension = { width: image.width, height: image.height };
          this.newData.offsetRight = image.width - newClip.width - newClip.offsetX;
          this.newData.offsetBottom = image.height - newClip.height - newClip.offsetY;
        }
      }, 1000);

    this.newData.minHeight *= this.newData.factor;
    this.newData.minWidth *= this.newData.factor;
    return newClip;
  }

  onCrop(event) {
    const selectionBox: any = document.querySelector('.selection-box');
    const box = selectionBox.getBoundingClientRect();
    const container = selectionBox.parentElement.getBoundingClientRect();
    const top = box.top - container.top;
    const left = box.left - container.left;
    this.newClip.width = box.width;
    this.newClip.height = box.height;
    this.newClip.offsetX = left;
    this.newClip.offsetY = top;

    this.newData.offsetRight = this.newData.imageDimension.width - this.newClip.width - this.newClip.offsetX;
    this.newData.offsetBottom = this.newData.imageDimension.height - this.newClip.height - this.newClip.offsetY;
    this.imageEditorSave.emit({ type: this.type, newClip: this.newClip, newData: this.newData });
  }

  onDragged(event: any) {
    const selectionBox: any = document.querySelector('.selection-box');
    const box = selectionBox.getBoundingClientRect();
    const container = selectionBox.parentElement.getBoundingClientRect();

    const top = box.top - container.top;
    const left = box.left - container.left;
    this.newClip.offsetX = left;
    this.newClip.offsetY = top;
    this.newData.offsetRight = this.newData.imageDimension.width - this.newClip.width - this.newClip.offsetX;
    this.newData.offsetBottom = this.newData.imageDimension.height - this.newClip.height - this.newClip.offsetY;
    this.imageEditorSave.emit({ type: this.type, newClip: this.newClip, newData: this.newData });
  }
}
